// extracted by mini-css-extract-plugin
module.exports = {"btn-bookmark":"btn-bookmark","is-bookmark":"is-bookmark","icon":"icon"};